/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Import_Decoding_Options_LabelInputs */



/**
* | output |
* | --- |
* | "Decoding Options" |
*
* @param {Subtitle_Import_Decoding_Options_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_import_decoding_options_label = /** @type {((inputs?: Subtitle_Import_Decoding_Options_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Import_Decoding_Options_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Options de decodage")
	if (locale === "de") return /** @type {LocalizedString} */ ("Dekodierungsoptionen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Opzioni di decodifica")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Варианты декодирования")
	if (locale === "es") return /** @type {LocalizedString} */ ("Opciones de decodificación")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("解码选项")
	if (locale === "ja") return /** @type {LocalizedString} */ ("デコードオプション")
	if (locale === "hi") return /** @type {LocalizedString} */ ("डिकोडिंग विकल्प")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Opções de decodificação")
	return /** @type {LocalizedString} */ ("Decoding Options")
});